import React from 'react';
import {
  CardContainer,
  ListLayout,
  TextBox,
  InlineLayout,
  FocusBackground,
  AlertContainer,
  Slider,
  Switch,
  HoverBox,
  CustomInput,
  InputBox,
  CusButton,
  Alert,
  Link,
  SliderSubCom,
  Loading,
} from './styles';
import { CSSTransition } from 'react-transition-group';
import 'overlayscrollbars/css/OverlayScrollbars.css';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import './styles/styles.css';
import './styles/styles.scss';
import LoadingBar from 'react-top-loading-bar';

export default function Core({ children }) {
  return <>{children}</>;
}

export const Scroll = ({ children, ...props }) => {
  return (
    <OverlayScrollbarsComponent
      options={{
        overflowBehavior: {
          x: 'hidden',
          y: 'scroll',
        },
      }}
      {...props}
    >
      {children}
    </OverlayScrollbarsComponent>
  );
};

Core.Loading = function CoreLoading({ children, color, ...props }) {
  return (
    <Loading color={color}>
      <LoadingBar color={color} {...props}>
        {children}
      </LoadingBar>
    </Loading>
  );
};

Core.CardContainer = function CoreCardContainer({
  width,
  height,
  showBox,
  setShowBox,
  forwardedRef = null,
  minWidth = null,
  forCom = 'default',
  setShowParentBox,
  children,
  ...restProps
}) {
  return (
    <>
      <FocusBackground
        showBox={showBox}
        onClick={() => setShowBox(false)}
      ></FocusBackground>

      <CSSTransition
        in={showBox}
        timeout={300}
        classNames='display'
        unmountOnExit
        onExited={() => {
          if (forCom != 'default') setShowParentBox(false);
        }}
      >
        <CardContainer
          ref={forwardedRef}
          showBox={showBox}
          minWidth={minWidth}
          width={width}
          height={height}
        >
          <div {...restProps}>{children}</div>
        </CardContainer>
      </CSSTransition>
    </>
  );
};

Core.ListLayout = function CoreListLayout({ children, ...restProps }) {
  return <ListLayout {...restProps}>{children}</ListLayout>;
};

Core.InlineLayout = function CoreInlineLayout({
  justifyContent,
  children,
  ...restProps
}) {
  return (
    <InlineLayout justifyContent={justifyContent} {...restProps}>
      {children}
    </InlineLayout>
  );
};

Core.List = function CoreList({
  childWidth = '',
  forwardedRef,
  addFlex = false,
  noBorderRadius = false,
  children,
  forMobile,
  ...restProps
}) {
  return (
    <Scroll
      className={`List${childWidth == 'full' ? ' childWidth' : ''}${
        noBorderRadius ? ' noBorderRadius' : ''
      }${forMobile ? ' forMobile' : ''}${addFlex ? ' addFlex' : ''}`}
    >
      <div
        ref={forwardedRef}
        {...restProps}
      >
        {children}
      </div>
    </Scroll>
  );
};

Core.Slider = function CoreSlider({
  showBox,
  screen = 'default',
  type = 'default',
  children,
  ...restProps
}) {
  return (
    <>
      {screen != 'Mobile' && screen != 'Signin' ? (
        <Slider showBox={showBox} {...restProps}>
          <Scroll className={`SliderSubCom${type == 'Task' ? ' Task' : ''}`}>
            {children[0]}
          </Scroll>
          <Scroll className={`SliderSubCom${type == 'Task' ? ' Task' : ''}`}>
            {children[1]}
          </Scroll>
        </Slider>
      ) : screen == 'Signin' ? (
        <Slider showBox={showBox} {...restProps}>
          <SliderSubCom type={type}>{children[0]}</SliderSubCom>
          <SliderSubCom type={type}>{children[1]}</SliderSubCom>
        </Slider>
      ) : (
        <Slider screen={screen} {...restProps}>
          <SliderSubCom showBox={showBox} type={type} screen={screen}>
            {children[0]}
          </SliderSubCom>
          <SliderSubCom showBox={showBox} type={type} screen={screen}>
            {children[1]}
          </SliderSubCom>
        </Slider>
      )}
    </>
  );
};

Core.Switch = function CoreSwitch({
  value,
  color,
  height = 18,
  style = null,
  ...props
}) {
  return (
    <Switch color={color} value={value} height={height} {...props}>
      <div style={style}>
        <div></div>
      </div>
    </Switch>
  );
};

Core.ForceAlert = function CoreForceAlert({
  showBox,
  color,
  zIndex = 9999,
  progress = null,
  setProgress = null,
  children,
}) {
  return (
    <>
      <FocusBackground showBox={showBox} zIndex={zIndex - 1}></FocusBackground>

      {progress > -1 && (
        <Core.Loading
          color={color}
          progress={progress}
          onLoaderFinished={() => setProgress(0)}
        />
      )}
      <CSSTransition
        in={showBox}
        timeout={300}
        classNames='display'
        unmountOnExit
      >
        <AlertContainer color={color} zIndex={zIndex}>
          {children}
        </AlertContainer>
      </CSSTransition>
    </>
  );
};

Core.TextArea = function CoreTextArea({
  forwardedRef = null,
  targetType = null,
  children,
  ...restProps
}) {
  return (
    <>
      <TextBox
        spellCheck='false'
        ref={forwardedRef}
        targetType={targetType}
        {...restProps}
      >
        {children}
      </TextBox>
    </>
  );
};

Core.NameInput = function CoreNameInput({
  forwardedRef = null,
  targetType = null,
  children,
  ...restProps
}) {
  return (
    <CustomInput
      spellCheck='false'
      ref={forwardedRef}
      targetType={targetType}
      {...restProps}
    >
      {children}
    </CustomInput>
  );
};

Core.Title = function CoreTitle({ children, ...restProps }) {
  return <h2 {...restProps}>{children}</h2>;
};

Core.Input = function CoreInput({ children, ...restProps }) {
  return (
    <InputBox spellCheck='false' {...restProps}>
      {children}
    </InputBox>
  );
};

Core.HoverHandle = function CoreHoverHandle({ children, ...restProps }) {
  return <HoverBox {...restProps}>{children}</HoverBox>;
};

Core.Button = function CoreButton({ children, normal = null, ...restProps }) {
  return (
    <CusButton normal={normal} {...restProps}>
      {children}
    </CusButton>
  );
};

Core.Success = function CoreSuccess({ children, ...restProps }) {
  return (
    <Alert type='success' color='#5dc466' bg='#e0ede1' {...restProps}>
      {children}
    </Alert>
  );
};

Core.Error = function CoreError({ children, ...restProps }) {
  return (
    <Alert type='error' color='#ea4e3d' bg='#ead4d2' {...restProps}>
      {children}
    </Alert>
  );
};

Core.Link = function CoreLink({ children, ...restProps }) {
  return <Link {...restProps}>{children}</Link>;
};

Core.Close = function CoreClose({ children, ...restProps }) {
  return <button {...restProps}>{children}</button>;
};
